import { useQuery } from '@tanstack/react-query';
import { meetingIssueApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Every meeting issue on a job plus the open/past-due/priority counters. */
export function useMeetingIssues(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.meetings.issues(jobId ?? -1),
    queryFn: ({ signal }) =>
      meetingIssueApiClient.getIssues(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    meta: { errorContext: 'meeting issues' },
  });
}
